import { GoalsState } from 'components/AICoach/Goals/Goals';

interface NavigationState<T = GoalsState> {
  state: T;
}

export const FROM_FINANCIAL_DASHBOARD_STATE: NavigationState = {
  state: { isFromFinancialDashboard: true },
};

export const OFFER_AVAILABLE_FROM_DASHBOARD_STATE: NavigationState<{ fromDashboard: boolean }> = {
  state: { fromDashboard: true },
};
